<mat-card>
  @if (!loading) {
  <mat-card-content>
    <table mat-table [dataSource]="trips">
      <ng-container *ngFor="let column of columns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>
          {{ columnLabels[column] }}
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container [ngSwitch]="column">
            <span *ngSwitchCase="'driver'">
              {{
                element.driver?.profile?.firstName +
                  " " +
                  element.driver?.profile?.lastName
              }}
            </span>
            <span *ngSwitchCase="'vehicle'">
              {{ element.vehicle?.manufacturer }}
            </span>
            <span *ngSwitchCase="'totalWeight'">
              {{ element.totalWeight }}
            </span>
            <span *ngSwitchCase="'totalVolume'">
              {{ element.totalVolume }}
            </span>
            <span *ngSwitchCase="'plannedAt'">
              {{ element.plannedAt | date : "dd/MM/yyyy HH:mm" }}
            </span>
            <span *ngSwitchCase="'completedAt'">
              {{ (element.completedAt | date : "dd/MM/yyyy HH:mm") || "-" }}
            </span>
            <span
              *ngSwitchCase="'status'"
              [ngClass]="utils.getTripStatusColor(element.status)"
            >
              {{ utils.getTripStatus(element.status) }}
            </span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        (click)="navToTripDetails(row.id)"
        *matRowDef="let row; columns: columns"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell p-2" [attr.colspan]="columns.length">No Trips</td>
      </tr>
    </table>
  </mat-card-content>
  } @else {
  <div class="my-3 d-flex justify-content-center">
    <mat-progress-spinner diameter="30" mode="indeterminate" color="primary">
    </mat-progress-spinner>
  </div>
  }

  <mat-card-actions>
    <mat-paginator
      (page)="onPageChange($event)"
      [length]="totalTrips"
      [pageSize]="pageSize"
      [pageSizeOptions]="[20, 50, 100]"
      [pageIndex]="pageIndex"
      aria-label="Select page"
    ></mat-paginator>
  </mat-card-actions>
</mat-card>
